import { render } from "./all_evaluation_results.vue?vue&type=template&id=0dddbe7c"
import script from "./all_evaluation_results.vue?vue&type=script&lang=js"
export * from "./all_evaluation_results.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__